import { render, staticRenderFns } from "./BaseBusiness.vue?vue&type=template&id=6c15fbc4&scoped=true&"
import script from "./BaseBusiness.vue?vue&type=script&lang=js&"
export * from "./BaseBusiness.vue?vue&type=script&lang=js&"
import style0 from "./BaseBusiness.vue?vue&type=style&index=0&id=6c15fbc4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c15fbc4",
  null
  
)

export default component.exports